var map = {
	"./ogate.png": "7278",
	"./ogatemini.png": "8932",
	"./ogates.png": "2fd6",
	"./ogatev8-t.png": "83a7",
	"./ogatev8.png": "a4f4",
	"./ogatev9-t.png": "f555",
	"./ogatev9.png": "9383",
	"./unknown.png": "e46c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10ee";